import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from "styled-components"

const Wrapper = styled.div`
  margin: 100px 0 0 0;
`

const Customers = () => (
  <StaticQuery
    query={graphql`
      query {
        banner: file(relativePath: { regex: "/baner-ojcowizna.jpg/" }) {
          childImageSharp {
            fluid(maxWidth: 1920) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => (
      <Wrapper>
        <a href="https://youtu.be/n-ojXBd5U-s" rel="noopener noreferrer" target="_blank">
          <Img fluid={data.banner.childImageSharp.fluid} />
        </a>
      </Wrapper>
    )}
  />
)
export default Customers;
